import { MutationTree } from 'vuex';
import { MetaAttributes, UtilityState } from '@/store/modules/utility/state';

export type Mutations<S = UtilityState> = {
  setFonts(state: S, fonts: string[]): void;
  setBodyClassList(state: S, classList: string[]): void;
  setHost(state: S, host: string): void;
  setCookies(state: S, cookies: string): void;
  setWindowHeight(state: S, height: number): void;
  setCampaignPadding(state: S, padding: number): void;
  setCurrentUrl(state: S, url: string): void;
  setMetatags(state: S, metaAttributes: MetaAttributes[]): void;
};

export const mutations: MutationTree<UtilityState> & Mutations = {
  setFonts: (state: UtilityState, fonts: string[]) => {
    state.fonts = fonts;
  },
  setBodyClassList: (state: UtilityState, classList: string[]) => {
    state.bodyClassList = classList;
  },
  setHost: (state: UtilityState, host: string) => {
    state.host = host;
  },
  setCookies: (state: UtilityState, host: string) => {
    state.cookies = host;
  },
  setWindowHeight: (state: UtilityState, height: number) => {
    state.windowHeight = height;
  },
  setCampaignPadding: (state: UtilityState, padding: number) => {
    state.campaignPadding = padding;
  },
  setCurrentUrl: (state: UtilityState, url: string) => {
    state.currentUrl = url;
  },
  setMetatags: (state: UtilityState, metaAttributes: MetaAttributes[]) => {
    state.metatags = metaAttributes;
  }
};
